export enum InfiniteScrollStatus {
  InitialLoading,
  NoItems,
  NoMoreItems,
  NetworkErrorWithNoData,
  ServerErrorWithNoData,
  NetworkErrorWithMoreData,
  ServerErrorWithMoreData,
  ReadyToLoadMore,
}
